module.exports = __webpack_public_path__ + "img/cross-alt.f05cee76.svg";